/*=========================================================
PRYVE PRESENCE EXPERIENCE
Version 2.1 - Complete (Quiz + Scoring + Results + Redirect)
=========================================================*/

document.addEventListener("DOMContentLoaded", () => {

  const quiz = document.querySelector("#pryve-presence");
  if (!quiz) return;

  /*======================================================
  ====  EDIT HERE - PERSONA CONTENT  ===================
  Answer position -> persona:
    answer 1 -> persona 0 (Comfort)
    answer 2 -> persona 1 (Power)
    answer 3 -> persona 2 (Luxury)
    answer 4 -> persona 3 (Passion)
  Update the Shopify product handle (part after /products/).
  ======================================================*/

  const PERSONAS = [
    // 0 - COMFORT
    {
      name:    "Biscuit Chaos",
      tagline: "Comfort was only the first impression.",
      story: [
        "Some people make everywhere feel familiar.",
        "They're the reason conversations last longer than planned, coffee turns into dinner, and 'I'll head out early' never quite happens.",
        "Biscuit Chaos was inspired by the kind of person who makes people feel at ease without ever asking for attention. Warm enough to draw you in. Unpredictable enough to make you stay.",
        "Comfort was only the first impression."
      ],
      notes:   ["Vanilla", "Cashmere", "Warm Sugar"],
      handle:  "biscuit-chaos"
    },
    // 1 - POWER
    {
      name:    "Don Favela",
      tagline: "The streets remember. The walls still whisper.",
      story: [
        "Every neighborhood has that one name people still bring up.",
        "Not because he was loud. Because he never needed to be.",
        "Don Favela is inspired by the man who grew up knowing every corner, every shortcut and every face. The streets shaped him, but they never defined him. Time traded the noise for tailored jackets, quiet confidence and old-money habits.",
        "He's outgrown proving himself. The respect stayed."
      ],
      notes:   ["Espresso", "Leather", "Smoked Oud"],
      handle:  "don-favela"
    },
    // 2 - LUXURY
    {
      name:    "Birkin Aura",
      tagline: "A whisper of sophistication. A statement that is never missed.",
      story: [
        "She'll complain about breaking a nail while helping you move a couch. She'll wear designer sunglasses to the supermarket and somehow make it look practical.",
        "She can spend the afternoon laughing over street food, then walk into dinner looking like she planned it all along.",
        "Birkin Aura isn't polished because life is perfect. It's polished because she is.",
        "Sophistication was never the occasion. It's the default."
      ],
      notes:   ["Champagne", "Silk", "White Florals"],
      handle:  "birkin-aura"
    },
    // 3 - PASSION
    {
      name:    "Red Bottoms",
      tagline: "As bold as the stride. As unforgettable as the scarlet sole.",
      story: [
        "Some people walk into a room to be noticed. Others are simply being themselves.",
        "Red Bottoms was inspired by the kind of person who never checks if they belong before they walk in. Elegant without trying. Relaxed in every room. The outfit is effortless, the standards aren't.",
        "They don't dress to prove a point. They've never had to. Whether it's sneakers on a Sunday morning or dressed for the evening, the presence never changes.",
        "Neither does the impression."
      ],
      notes:   ["Cherry", "Velvet", "Dark Rose"],
      handle:  "red-bottoms"
    }
  ];

  // The "Complete Your Presence" button (bundle/collection link):
  const BUNDLE_URL = "/collections/all";

  /*======================================================
  Screens
  ======================================================*/
  const introScreen   = quiz.querySelector('[data-screen="intro"]');
  const quizScreen    = quiz.querySelector('[data-screen="quiz"]');
  const loadingScreen = quiz.querySelector('[data-screen="loading"]');
  const resultScreen  = quiz.querySelector('[data-screen="result"]');
  const startButton   = document.getElementById("pp-start");

  /*======================================================
  Question Elements
  ======================================================*/
  const questionNumber   = document.getElementById("pp-question-number");
  const questionTitle    = document.getElementById("pp-question-title");
  const questionSubtitle = document.getElementById("pp-question-subtitle");
  const answersContainer = document.getElementById("pp-answers");
  const progressFill     = document.getElementById("pp-progress-fill");
  const currentNumber    = document.getElementById("pp-current");
  const totalNumber      = document.getElementById("pp-total");

  /*======================================================
  Result Elements
  ======================================================*/
  const percentEl          = document.getElementById("pp-percent");
  const personaEl          = document.getElementById("pp-persona");
  const taglineEl          = document.getElementById("pp-tagline");
  const storyEl            = document.getElementById("pp-story");
  const notesEl            = document.getElementById("pp-notes");
  const secondaryTitleEl   = document.getElementById("pp-secondary-title");
  const secondaryPercentEl = document.getElementById("pp-secondary-percent");
  const secondaryStoryEl   = document.getElementById("pp-secondary-story");
  const productBtn         = document.getElementById("pp-product");
  const bundleBtn          = document.getElementById("pp-bundle");
  const restartBtn         = document.getElementById("pp-restart");
  const loadingFill        = document.getElementById("pp-loading-fill");

  /*======================================================
  Questions
  ======================================================*/
  const questions = [
    { title:"When people remember you, what do they remember first?", subtitle:"Choose instinctively.",
      answers:["How comfortable they felt","How powerful I seemed","How elegant everything became","How impossible I was to ignore"] },
    { title:"Pick a place.", subtitle:"Don't overthink it.",
      answers:["A warm kitchen","A rooftop after midnight","A luxury hotel lobby","A red velvet lounge"] },
    { title:"Choose a drink.", subtitle:"First instinct wins.",
      answers:["Vanilla latte","Espresso","Champagne","Cherry cocktail"] },
    { title:"What kind of energy attracts you?", subtitle:"Choose one.",
      answers:["Comfort","Mystery","Luxury","Passion"] },
    { title:"Pick a texture.", subtitle:"",
      answers:["Cashmere","Leather","Silk","Velvet"] },
    { title:"Your ideal evening?", subtitle:"",
      answers:["Movie at home","Private dinner","Five-star hotel","Late-night adventure"] },
    { title:"Choose a word.", subtitle:"",
      answers:["Warmth","Control","Elegance","Desire"] },
    { title:"Which sentence feels like you?", subtitle:"",
      answers:["They feel safe with me.","I never need to raise my voice.","I belong anywhere.","I leave an impression."] }
  ];

  let currentQuestion = 0;
  let scores = [0, 0, 0, 0];

  /*======================================================
  Show Screen
  ======================================================*/
  function showScreen(screen){
    [introScreen, quizScreen, loadingScreen, resultScreen].forEach(s => s.classList.remove("is-active"));
    screen.classList.add("is-active");
    quiz.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /*======================================================
  Render Question
  ======================================================*/
  function renderQuestion(){
    const q = questions[currentQuestion];
    questionNumber.textContent   = "Question " + (currentQuestion + 1);
    questionTitle.textContent    = q.title;
    questionSubtitle.textContent = q.subtitle;

    answersContainer.innerHTML = "";
    q.answers.forEach((answer, index) => {
      const btn = document.createElement("button");
      btn.className = "pp-answer";
      btn.textContent = answer;
      btn.dataset.index = index;
      btn.addEventListener("click", () => selectAnswer(index));
      answersContainer.appendChild(btn);
    });

    currentNumber.textContent = currentQuestion + 1;
    totalNumber.textContent   = questions.length;
    progressFill.style.width  = (currentQuestion / questions.length) * 100 + "%";
  }

  /*======================================================
  Select Answer (records score, then advances)
  ======================================================*/
  function selectAnswer(index){
    scores[index]++;
    currentQuestion++;

    if (currentQuestion >= questions.length){
      progressFill.style.width = "100%";
      runLoading();
      return;
    }
    renderQuestion();
  }

  /*======================================================
  Loading -> Result
  ======================================================*/
  function runLoading(){
    showScreen(loadingScreen);
    if (loadingFill) loadingFill.style.width = "0%";
    requestAnimationFrame(() => {
      if (loadingFill) loadingFill.style.width = "100%";
    });
    setTimeout(showResult, 2600);
  }

  /*======================================================
  Compute + Show Result
  ======================================================*/
  function showResult(){
    const ranked = scores
      .map((score, i) => ({ i, score }))
      .sort((a, b) => b.score - a.score);

    const primary   = PERSONAS[ranked[0].i];
    const secondary = PERSONAS[ranked[1].i];

    const total        = questions.length;
    const primaryPct   = Math.round(72 + (ranked[0].score / total) * 28);
    const secondaryPct = Math.round(72 + (ranked[1].score / total) * 28);

    percentEl.textContent = primaryPct;
    personaEl.textContent = primary.name;
    taglineEl.textContent = primary.tagline;

    storyEl.innerHTML = "";
    primary.story.forEach(par => {
      const p = document.createElement("p");
      p.textContent = par;
      storyEl.appendChild(p);
    });

    notesEl.innerHTML = "";
    primary.notes.forEach(note => {
      const span = document.createElement("span");
      span.className = "pp-note";
      span.textContent = note;
      notesEl.appendChild(span);
    });

    secondaryTitleEl.textContent   = secondary.name;
    secondaryPercentEl.textContent = secondaryPct + "%";
    secondaryStoryEl.textContent   = secondary.tagline;

    // REDIRECT: product link based on the winning persona
    productBtn.setAttribute("href", "/products/" + primary.handle);
    bundleBtn.addEventListener("click", () => { window.location.href = BUNDLE_URL; }, { once: true });

    showScreen(resultScreen);
  }

  /*======================================================
  Start
  ======================================================*/
  startButton.addEventListener("click", () => {
    currentQuestion = 0;
    scores = [0, 0, 0, 0];
    showScreen(quizScreen);
    renderQuestion();
  });

  /*======================================================
  Restart
  ======================================================*/
  if (restartBtn){
    restartBtn.addEventListener("click", () => {
      currentQuestion = 0;
      scores = [0, 0, 0, 0];
      progressFill.style.width = "0%";
      showScreen(introScreen);
    });
  }

});